// inputs.js
import { validateRequired,validateLength, validateDateRange ,
  validateStartDate
}from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    name: "tem_descripcion",
    type: "text",
    label: "Nombre de la Temporada",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }
    
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }
    
      // Si no hay errores
      return null;
    }    
  },
  {
    id: 2,
    name: "tem_fechainicio",
    type: "date",
    label: "Fecha de Inicio",
    validation: (value, form) => {
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }
      return validateStartDate(value);
    },
  },
  {
    id: 3,
    name: "tem_fechafin",
    type: "date",
    label: "Fecha de Fin",
    validation: (value, form) => {
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }
      return validateDateRange(value, form, 'tem_fechainicio', 'tem_fechafin');
    },
  }
  // Agrega más campos aquí
];

export default Inputs;
